import { FC, type SVGProps } from 'react'

import { CustomIconProps } from '@/shared/lib/@deprecated/iport-icons'

/** Partner-bank logo strips are static assets, not icons — they must not be bundled into JS. */
export interface BankLogo {
	src: string
	alt: string
	width: number
	height: number
}

export interface BankData {
	title: string
	pic: BankLogo & {
		extraBanks?: BankLogo
	}
	percent: string
	initialFee: string
	sum: string
	term: string
	extraNode?: {
		icon?: FC<CustomIconProps | SVGProps<SVGSVGElement>>
		text: string
		link?: { text: string; href: string }
	}
	availableDevices: ProductAvailableDevices[] | availableDevicesEnum
}

export interface ProductAvailableDevices {
	label: string
	link: string
}

export enum availableDevicesEnum {
	All = 'all'
	// Never = 'never' Оставил пока что с целью расширения потом
}
